import React from 'react';

import Button from 'components/Button';

import './styles.css';

const LegacyDocumentUploadButtons = ({
  submitForm,
  submitDisabled,
  submitting
}) => (
  <div className="LegacyDocumentUploadButtons">
    <Button
      blue={!submitDisabled}
      className="submit"
      onClick={submitForm}
      isLoading={submitting}
      disabled={submitDisabled}>
      Save
    </Button>
  </div>
);

export default LegacyDocumentUploadButtons;
